interface ProcessedLogoProps {
  className?: string;
}

const ProcessedLogo = ({ className }: ProcessedLogoProps) => {
  return (
    <div className={className}>
      <img 
        src="/lovable-uploads/c325d0e4-f21b-4854-acf2-360ae2b9ab61.png" 
        alt="Organize by Design logo" 
        className="h-10 w-auto drop-shadow"
        width={123}
        height={70}
        decoding="async"
      />
    </div>
  );
};

export default ProcessedLogo;
